import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  newDiscountCouponSidebar: {
    id: undefined,
    visible: false,
    saveAction: undefined,
  },
  discountCouponsSearchResult: [],
}

export default {
  state,
  actions,
  getters,
  mutations
}
